import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

const emailsUrl = "/api/v1/poolcorp/contactUs";

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
    accountId?: string;
}

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${emailsUrl}/submitContactUs`, parameter);
}